import { Box, Flex } from "@chakra-ui/react";
import SkeletonComponent from "@components/skeleton";

const CardHeadSkeleton = ({ ...props }) => {
    return (
        <Box
            p={'16px 24px'}
            bg={'semantic.100'}
            border={'1px solid'}
            borderColor={'neutral.200'}
            borderRadius={'8px'}
            {...props}
        >
            <Flex gap={'16px'} alignItems={'center'} mb={'4px'}>
                <SkeletonComponent width="100%" maxWidth={'24px'} height={'24px'} />
                <SkeletonComponent width="100%" maxWidth={'120px'} height={'28px'} />
            </Flex>
            <Flex ml={'40px'} gap={'16px'} alignItems={'center'}>
                <SkeletonComponent width="100%" maxWidth={'16px'} height={'16px'} />
                <SkeletonComponent width="100%" maxWidth={'680px'} height={'20px'} />
            </Flex>
        </Box>
    );
};

export default CardHeadSkeleton;
